/* eslint-disable import/prefer-default-export */
import React, { isValidElement } from 'react'
import twemoji from 'twemoji'
import { Emoji } from 'schemas/EmojiSchema'
import messageUtil from 'utils/messageUtil'
import EmojiCategory from 'enums/EmojiCategory'

const EMOJI_CDN = 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/'

export const extractEmojiDisplayText = (emojiItem: Emoji): string | undefined => {
  switch (emojiItem.category) {
    case EmojiCategory.EMOTION:
    case EmojiCategory.TYPE:
      return messageUtil.emojisLabel(emojiItem.name!)
    case EmojiCategory.EMOJI:
    default:
      return emojiItem.id
  }
}

const parseTwemojiWithCdnReplacement = (item: string) =>
  twemoji.parse(item, {
    base: EMOJI_CDN
  })

export const getTwEmoji = (item: string): React.ReactNode => {
  const el = document.createElement('html')
  el.innerHTML = parseTwemojiWithCdnReplacement(item)
  if (el.getElementsByTagName('img').length > 0) {
    const image = el.getElementsByTagName('img')[0]
    return <img width="14px" alt={item!} src={image.getAttribute('src')!} />
  }
  return ''
}

export const getTwEmojiImgUrl = (item: string) => {
  const emoji = getTwEmoji(item)
  if (isValidElement<HTMLImageElement>(emoji)) {
    return emoji.props.src
  }
  return ''
}

export const replaceEmojiWithTwEmoji = (item: string) => {
  const el = document.createElement('body')
  el.innerHTML = parseTwemojiWithCdnReplacement(item)

  Array.from(el.getElementsByTagName('img')).forEach((imageElement) => {
    imageElement.setAttribute('width', '14px')
  })

  return el.innerHTML
}
